module.exports = __webpack_public_path__ + "img/step3.c688d2e4.png";